module.exports = __webpack_public_path__ + "img/magento_3.2608b8fe.png";